module.exports = __webpack_public_path__ + "media/src/images/abouts/items/delivery/tiegift-ed0e1966819474ab99e1be89ce91ff81.jpg";